import React from 'react';
import PropTypes from 'prop-types';
import styles from './EventListingsBillingContactInfo.module.scss';

import ControlledFormInput from '../../../../common/components/ControlledFormInput';

const EventListingsBillingContactInfo = ({
  billingContactEmail,
  billingContactName,
  billingContactInfoReadOnly,
  setBillingContactInfoReadOnlyOnChange,
  setField,
  validateField,
}) => {
  return (
    <form>
      <fieldset>
        <label className={styles.label} htmlFor="same_as_contact">
          <input
            type="radio"
            id="same_as_contact"
            name="billing_contact_info_needed"
            onChange={setBillingContactInfoReadOnlyOnChange}
            checked={billingContactInfoReadOnly}
            value="true"
          />
          Same as contact information
        </label>
        <label className={styles.label} htmlFor="different_billing_contact">
          <input
            type="radio"
            id="different_billing_contact"
            name="billing_contact_info_needed"
            onChange={setBillingContactInfoReadOnlyOnChange}
            checked={!billingContactInfoReadOnly}
            value="false"
          />
          Use a different billing contact
        </label>
      </fieldset>
      <div>
        <ControlledFormInput
          field={billingContactName}
          fieldName="billingContactName"
          onChange={setField}
          onBlur={validateField}
          value={billingContactName.value}
          readOnly={billingContactInfoReadOnly}
          required
        />
        <ControlledFormInput
          field={billingContactEmail}
          fieldName="billingContactEmail"
          onChange={setField}
          onBlur={validateField}
          value={billingContactEmail.value}
          readOnly={billingContactInfoReadOnly}
          required
        />
      </div>
    </form>
  );
};

EventListingsBillingContactInfo.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  billingContactName: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  billingContactEmail: PropTypes.object.isRequired,
  billingContactInfoReadOnly: PropTypes.bool.isRequired,
  setBillingContactInfoReadOnlyOnChange: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
};

export default EventListingsBillingContactInfo;
